(function componentForm($, Adzuki, tinymce) {
	'use strict';

	var form = {
		name: 'LivePlannerSummaryFollowup',
	};

	$(document).ready(function onDocumentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.lp-link-url').on('click', function _addLinks(e) {
			e.preventDefault();

			setLinks($(this).data('url'), $(this).data('label'));
		});
	};

	function setLinks(url, label) {
		var editor, // eslint-disable-line no-unused-vars
			content;

		editor = Adzuki.Editor('#lp-message', {
			init_instance_callback: function onEditorInit(_editor) {
				// get the editor's current content
				content = _editor.getContent();
				content += '<p class="lp-follow-link"><a href="' + url + '" target="_blank">' + label + '</a></p>';

				// set the editor to new content
				_editor.setContent(content);

				$('#lp-message').val(content);
			},
		});
	}
}(jQuery, window.Adzuki || {}, window.tinymce || {}));